import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'widgets/Icon/Icon';

const TitleBar = ({ children, close, className }) => (
  <div className={`gn-bar gn-titleBar ${className}`}>
    <div className="gn-titleBar__wrapper">
      {children}
      {close && (
        <button
          aria-label="Close"
          className="gn-titleBar__close"
          onClick={close}
        >
          <Icon name="close" />
        </button>
      )}
    </div>
    <div className="gn-divider" />
  </div>
);

TitleBar.propTypes = {
  close: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TitleBar;
